import { Component, OnInit, inject } from '@angular/core';
import {Destroyed} from 'src/app/components/shared/directives/destroyed.directive';
import {LoadingService} from 'src/app/services/loading.service';
import {debounceTime} from 'rxjs/operators';

@Component({
  selector: 'app-loading',
  standalone: true,
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss'
})
export class LoadingComponent extends Destroyed implements OnInit {
  private readonly loadingService = inject(LoadingService);

  loading = false;

  ngOnInit() {
    this.loadingService.loadingStatus
      .pipe(debounceTime(50), this.untilDestroyed())
      .subscribe((value) => {
        this.loading = value;
      });
  }
}
